import React, { useEffect, useState } from "react";
import SectionHeader from "../../components/commonUi/SectionHeader";
import { BsSearch } from "react-icons/bs";
import { GoPlus } from "react-icons/go";
import TeamCreateModal from "../../components/Modals/TeamCreateModal";
import apiClient from "../../service/Axios";
import { ProgressSpinner } from "primereact/progressspinner";
import TeamDetailsModal from "../../components/Modals/TeamDetailsModal";
import TeamCreateCard from "../../components/Card/TeamCreateCard";

const TeamPage = () => {
  const [visible, setVisible] = useState(false);
  const [team, setTeam] = useState([]);
  const [loading, setLoding] = useState(false);
  const [detailsvisible, setDetailsVisible] = useState(false);
  const [selectedTeam, setSelectedTeam] = useState(null);

  const handleCardClick = (teamData) => {
    setSelectedTeam(teamData);
    setDetailsVisible(true);
  };

  const teamGetFuc = () => {
    setLoding(true);
    apiClient
      .get(`${process.env.REACT_APP_API}/user/teams/list-with-member-data`)
      .then((res) => {
        setTeam(res?.data);
        // console.log("teaminfo", res?.data);
        setLoding(false);
      });
  };
  useEffect(() => {
    teamGetFuc();
  }, []);

  // const fetchTeamMembers = (teamId) => {
  //   apiClient
  //     .get(`${process.env.REACT_APP_API}/user/teams/${teamId}/member/list`)
  //     .then((res) => {
  //       console.log(`Members for team ${teamId}:`, res.data);
  //       // You can handle the team members data here, e.g., store it in state
  //     })
  //     .catch((error) => {
  //       console.error(`Error fetching members for team ${teamId}:`, error);
  //     });
  // };

  // console.log("selectedTeam", selectedTeam);
  return (
    <div className="px-7">
      <div className="flex justify-between items-center">
        <SectionHeader title={"Team"} objective={"Create manage your team."} />
        <div className="flex justify-center items-center gap-8 mt-4">
          <div className="relative">
            <BsSearch className="absolute top-2.5 left-3 text-gray-500" />
            <input
              type="name"
              id="search"
              placeholder="Search"
              name="search"
              className="pl-10 border border-gray-400 w-full rounded-[5px] h-9"
            />
          </div>

          <button
            className="hover:bg-[#161B22] bg-[#161b22d1] text-white font-normal py-2 px-4 rounded-md inline-flex items-center"
            onClick={() => setVisible(true)}>
            <GoPlus className="font-bold text-xl" />
            <span>Create Team</span>
          </button>
        </div>
      </div>
      <div className="mt-5">
        {loading ? (
          <div className="flex justify-center items-center mt-20">
            <ProgressSpinner
              style={{ width: "50px", height: "50px" }}
              strokeWidth="4"
              animationDuration=".5s"
            />
          </div>
        ) : (
          <div className="grid lg:grid-cols-4 grid-cols-1 md:grid-cols-1 gap-10">
            {team?.map((teamData, i) => {
              // console.log("teamData", teamData);
              return (
                <div
                  key={i}
                  onClick={() => {
                    handleCardClick(teamData);
                    // fetchTeamMembers(teamData.id);
                  }}>
                  <TeamCreateCard data={teamData} />
                  {/* Fetch and display team members for each team */}
                </div>
              );
            })}
          </div>
        )}
      </div>

      <TeamDetailsModal
        setDetailsVisible={setDetailsVisible}
        detailsvisible={detailsvisible}
        selectedTeam={selectedTeam}
        setSelectedTeam={setSelectedTeam}
        teamGetFuc={teamGetFuc}
      />
      <TeamCreateModal
        visible={visible}
        setVisible={setVisible}
        teamGetFuc={teamGetFuc}
      />
    </div>
  );
};

export default TeamPage;
